import { render, staticRenderFns } from "./shareConfig.vue?vue&type=template&id=6e08dbd8&scoped=true"
import script from "./shareConfig.vue?vue&type=script&lang=js"
export * from "./shareConfig.vue?vue&type=script&lang=js"
import style0 from "./shareConfig.vue?vue&type=style&index=0&id=6e08dbd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e08dbd8",
  null
  
)

export default component.exports